import { AgentType } from '@common/api';
import type { TranslationFunctions } from '@i18n/i18n-types';

export const DEFAULT_AGENT_TYPE: AgentType = AgentType.Analyst;

interface AgentTypeConfig {
    getDisplayName: (LL: TranslationFunctions) => string;
    getSuggestedPrompts: (LL: TranslationFunctions) => string[];
}

const AGENT_TYPE_CONFIG: Record<AgentType, AgentTypeConfig> = {
    [AgentType.Analyst]: {
        getDisplayName: (LL) => LL.CHAT_AGENT_TYPE_ANALYST(),
        getSuggestedPrompts: (LL) => [
            LL.CHAT_SUGGESTED_SUMMARY(),
            LL.CHAT_SUGGESTED_DIMENSIONS(),
            LL.CHAT_SUGGESTED_DELAY(),
            LL.CHAT_SUGGESTED_ON_DEMAND(),
            LL.CHAT_SUGGESTED_MEASURES(),
            LL.CHAT_SUGGESTED_FIXED_DIMENSION(),
            LL.CHAT_SUGGESTED_DATE_PROPERTY(),
        ],
    },
};

export function getAgentTypeConfig(agentType: AgentType | undefined): AgentTypeConfig {
    return AGENT_TYPE_CONFIG[agentType ?? DEFAULT_AGENT_TYPE];
}
